import { sumOrNull } from './math'

const buildMonths = ({ data }) => {
  const monthKeys = [...new Set(
    data.map(d => `${d.year}-${String(d.month).padStart(2, '0')}`)
  )].sort();

  const months = monthKeys.map(key => {
    const [year, month] = key.split('-');
    return `${new Date(Number(year), Number(month) - 1)
      .toLocaleString('pt-BR', { month: 'short' })
      .toUpperCase()}/${String(year).slice(2)}`;
  });

  return { monthKeys, months };
};

export const buildSharedMonths = (dataArrays) => buildMonths({ data: dataArrays.flat() });

export const getCurrentMonthKey = () => {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
};

export const pickByMonth = ({ monthKey, currentMonthKey, planValue, realValue }) =>
  monthKey < currentMonthKey
    ? (realValue ?? planValue ?? null)
    : (planValue ?? realValue ?? null);

export const buildSummaryPeriods = (monthKeys) => {
  const byYear = new Map();
  monthKeys.forEach((key, index) => {
    const [year, month] = key.split('-').map(Number);
    if (!byYear.has(year)) byYear.set(year, { s1: [], s2: [] });
    byYear.get(year)[month <= 6 ? 's1' : 's2'].push(index);
  });

  const periods = [];
  for (const [year, { s1, s2 }] of byYear) {
    const s1Closed = s1.length === 6;
    const s2Closed = s2.length === 6;
    if (s1Closed) periods.push({ key: `sem1-${year}`, type: 'semester', label: '1° SEM', monthIndexes: s1, afterIndex: s1[5] });
    if (s2Closed) periods.push({ key: `sem2-${year}`, type: 'semester', label: '2° SEM', monthIndexes: s2, afterIndex: s2[5] });
    if (s1Closed && s2Closed) periods.push({ key: `total-${year}`, type: 'total', label: 'TOTAL', monthIndexes: [...s1, ...s2], afterIndex: s2[5] });
  }
  return periods;
};

export const summarizeRaw = (rawValues, summaryPeriods) =>
  summaryPeriods.map(p => sumOrNull(p.monthIndexes.map(i => rawValues[i])));

export const formatSummary = (semRawValues, fmt) => semRawValues.map(v => v != null ? fmt(v) : null);

export const summarizeField = (agg, field, summaryPeriods, fmt) =>
  formatSummary(summarizeRaw(agg.map(d => d[field]), summaryPeriods), fmt);